import React from 'react';
import Image from 'next/image';

const ValueProposition = () => {
    return (
        <div className="section-py relative bg-black">
            <div className="bg-agriculture-numbers">
            <video playsInline autoPlay muted loop className="aimlvideo h-[385px] counter-overlay-value" width="100%">
                <source src="media/aiml-section.mp4" type="video/mp4" />
            </video>
            </div>
            <div className="container xl:container mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-9">
                    <div className="lg:col-span-10 gap-4 grid">
                        <h2 className="text-white mb-0">
                            Value Proposition
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_theproblemwesolve.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">The problem we solve</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Fragmented knowledge systems, prolonged support SLAs, and a lack of intelligent domain-aware assistants across business functions.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_ourcorecapabilities.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                           width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Our core capabilities</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Retrieval-Augmented Generation (RAG), LLMs for enterprise, prompt engineering, embeddings, vector database integrations, multi-lingual pipelines, enterprise RAG solutions, and speech systems.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_outcomeexamples.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Outcome examples</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            60% faster support resolution, 40% fewer escalations, improved knowledge findability with up to 95% semantic search accuracy, and context-aware responses.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ValueProposition;
